import React from 'react';
import { Typography, Grid } from '@mui/material';
import { useTranslation } from 'next-i18next';
import {
  FilterAccordion,
  FilterAccordionSummary,
  FilterAccordionDetails,
  PriceInput,
  PriceButton,
  Divider
} from '../styledComponents';
import { ExpandMoreIcon } from './ExpandMoreIcon';

interface AreaSectionProps {
  isExpanded: boolean;
  isVisible: boolean;
  onToggle: (event: React.MouseEvent) => void;
  areaMin: number;
  areaMax: number;
  areaMinInput: string;
  areaMaxInput: string;
  areaRangesMin: number[];
  areaRangesMax: number[];
  onAreaMinInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onAreaMaxInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onAreaMinSelect: (area: number) => void;
  onAreaMaxSelect: (area: number) => void;
}

export const AreaSection: React.FC<AreaSectionProps> = ({
  isExpanded,
  isVisible,
  onToggle,
  areaMin,
  areaMax,
  areaMinInput,
  areaMaxInput,
  areaRangesMin,
  areaRangesMax,
  onAreaMinInputChange,
  onAreaMaxInputChange,
  onAreaMinSelect,
  onAreaMaxSelect,
}) => {
  const { t } = useTranslation();

  if (!isVisible) return null;

  return (
    <>
      <FilterAccordion className={isExpanded ? 'expanded' : ''}>
        <FilterAccordionSummary 
          className={isExpanded ? 'expanded' : ''}
          onClick={onToggle}
        >
          <Typography className="section-title" variant="subtitle1" fontWeight="medium">
            {t('useable_area')}
          </Typography>
          <ExpandMoreIcon className="expand-icon" />
        </FilterAccordionSummary>
        {isExpanded && (
          <FilterAccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <PriceInput
                  placeholder="พื้นที่ขั้นต่ำ"
                  value={areaMinInput}
                  onChange={onAreaMinInputChange}
                />
                <div style={{ marginTop: '8px' }}>
                  {areaRangesMin.map((area) => (
                    <PriceButton 
                      key={`area-min-${area}`}
                      onClick={() => onAreaMinSelect(area)}
                    >
                      {area === 0 ? 'ไม่ระบุ' : area + ' ตร.ม.'}
                    </PriceButton>
                  ))}
                </div>
              </Grid>
              <Grid item xs={6}>
                <PriceInput
                  placeholder="พื้นที่สูงสุด"
                  value={areaMaxInput}
                  onChange={onAreaMaxInputChange}
                />
                <div style={{ marginTop: '8px' }}>
                  {areaRangesMax.map((area) => (
                    <PriceButton 
                      key={`area-max-${area}`}
                      onClick={() => onAreaMaxSelect(area)}
                    >
                      {area + ' ตร.ม.'}
                    </PriceButton>
                  ))}
                </div>
              </Grid>
            </Grid>
          </FilterAccordionDetails>
        )}
      </FilterAccordion>
      <Divider />
    </>
  );
}; 